export const services = [
  {
    slug: "coronary-angiography-angioplasty",
    title: "Coronary Angiography & Angioplasty (PTCA)",
    short: "State-of-the-art diagnostic imaging and minimally invasive treatment for blocked heart arteries.",
    image: "/images/facilities/DSC09668.jpg",
    icon: "HeartPulse",
    bullets: ["Precise diagnosis of blockages", "Stent placement (PTCA)", "Minimally invasive recovery"],
    long: [
      "Coronary angiography is the gold standard for visualizing blockages in the heart’s arteries. Dr. Ashish Gupta performs this with high precision, ensuring an accurate diagnosis before mapping out the best treatment plan.",
      "If blockages are found, an Angioplasty (PTCA) is performed to restore blood flow using a stent. With over 20+ years of expertise, Dr. Gupta ensures a safe procedure with swift recovery times, often allowing patients to return home shortly after."
    ],
    highlights: [
      "Radial (wrist) and Femoral approach",
      "Medicated stent placement",
      "Fast recovery and minimal discomfort",
      "Precision diagnosis of artery disease",
      "Immediate restoration of blood flow"
    ]
  },
  {
    slug: "complex-coronary-interventions",
    title: "Complex & Multivessel Coronary Interventions",
    short: "Advanced techniques for managing severe and multi-vessel blockages without open-heart surgery.",
    image: "/images/facilities/DSC04279.jpg",
    icon: "Activity",
    bullets: ["Bifurcation stenting", "Left main interventions", "Calcified lesion management"],
    long: [
      "Not all blockages are simple. Complex coronary artery disease, including multi-vessel involvement, left main disease, or heavily calcified lesions, requires specialized skills and advanced equipment.",
      "Dr. Gupta is highly experienced in navigating these challenging anatomies using techniques like rotational atherectomy and intravascular imaging (IVUS/OCT) to achieve optimal, long-lasting results without the need for bypass surgery."
    ],
    highlights: [
      "Left Main Coronary Artery stenting",
      "Bifurcation lesion treatment",
      "Rotational Atherectomy (Roatablation)",
      "IVUS / OCT guided precision",
      "Alternative to CABG (Bypass)"
    ]
  },
  {
    slug: "primary-angioplasty-heart-attack",
    title: "Primary Angioplasty for Acute Myocardial Infarction",
    short: "Emergency, life-saving intervention during a heart attack to restore vital blood flow.",
    image: "/images/facilities/DSC04277.jpg",
    icon: "Siren",
    bullets: ["24x7 emergency response", "Rapid vessel opening", "Life-saving care"],
    long: [
      "Time is muscle during a heart attack. Primary angioplasty is the most effective treatment for an acute myocardial infarction, physically opening the blocked artery to prevent permanent heart damage.",
      "WellMed Hospitals' cath lab operates 24/7. Under Dr. Gupta’s leadership, the team is equipped to respond instantly, minimizing 'door-to-balloon' time and maximizing the chances of a full recovery."
    ],
    highlights: [
      "Round-the-clock emergency team",
      "Minimal door-to-balloon time",
      "Thrombus aspiration techniques",
      "Critical care and ICU support",
      "Post-heart attack rehabilitation"
    ]
  },
  {
    slug: "pacemaker-icd-crt",
    title: "Pacemaker, ICD & CRT Device Implantation",
    short: "Advanced electrical devices to regulate slow, fast, or unsynchronized heartbeats.",
    image: "/images/facilities/DSC09788.jpg",
    icon: "Zap",
    bullets: ["Permanent pacemakers", "Implantable cardioverter-defibrillators (ICD)", "Cardiac resynchronization therapy (CRT)"],
    long: [
      "When the heart’s electrical system malfunctions, leading to arrhythmias (irregular heartbeats) or heart failure, implantable devices provide a reliable safeguard.",
      "Dr. Gupta routinely implants permanent pacemakers for slow heart rates, ICDs to prevent sudden cardiac arrest, and CRT devices to improve the heart's pumping efficiency in heart failure patients."
    ],
    highlights: [
      "Single and Dual Chamber Pacemakers",
      "Leadless pacemaker options",
      "ICD implantation for arrhythmia",
      "CRT-P and CRT-D for heart failure",
      "Routine device programming and follow-up"
    ]
  },
  {
    slug: "peripheral-renal-interventions",
    title: "Peripheral & Renal Vascular Interventions",
    short: "Treating blockages outside the heart to improve circulation in the legs, arms, and kidneys.",
    image: "/images/facilities/DSC09795.jpg",
    icon: "Activity",
    bullets: ["Leg pain (Claudication) treatment", "Renal artery stenting", "Carotid interventions"],
    long: [
      "Atherosclerosis affects not just the heart, but arteries throughout the body. Blockages in the legs can cause severe pain while walking, and blockages in the renal arteries can lead to uncontrollable hypertension.",
      "Utilizing minimally invasive endovascular techniques, Dr. Gupta opens these peripheral blockages using balloons and stents, significantly improving circulation, alleviating pain, and preventing complications like limb loss or kidney failure."
    ],
    highlights: [
      "Peripheral angioplasty and stenting",
      "Renal artery stenosis treatment",
      "Diabetic foot vascular care",
      "Carotid artery stenting",
      "Subclavian artery interventions"
    ]
  },
  {
    slug: "preventive-cardiology",
    title: "Preventive Cardiology & Lifestyle Management",
    short: "Proactive strategies to identify risks and prevent heart disease before it strikes.",
    image: "/images/facilities/p2.jpeg",
    icon: "ShieldCheck",
    bullets: ["Risk assessment profiling", "Cholesterol and BP management", "Dietary and lifestyle counseling"],
    long: [
      "Heart disease is largely preventable. Dr. Gupta emphasizes a proactive approach, identifying hidden risks through advanced lipid profiling, genetic history assessment, and comprehensive health evaluations.",
      "Rather than just prescribing medication, the focus is on a holistic transformation—integrating diet, exercise, and stress management to reverse early signs of disease and maintain long-term cardiovascular health."
    ],
    highlights: [
      "Comprehensive cardiac risk profiling",
      "Hypertension and dyslipidemia management",
      "Diabetes-cardiac risk correlation",
      "Smoking cessation guidance",
      "Personalized exercise and diet plans"
    ]
  }
];

export const testimonials = [
  {
    name: "Piyush Adlakha",
    text: "We recently visited Dr. Ashish Gupta for a general cardiac consultation and preventative check-up, and we couldn't be more pleased with the care we received. Dr. Gupta immediately impressed us with his professionalism and his calm approach.",
    date: "5 months ago"
  },
  {
    name: "Inderjeet Yadav",
    text: "I would like to express my heartfelt gratitude to Dr. Ashish Gupta, one of the finest cardiologists I have met. My angioplasty procedure was handled with great expertise and care. From the initial consultation to post-surgery recovery, everything was seamless.",
    date: "7 months ago"
  }
];

export const faqs = [
  {
    q: "What conditions does Dr. Ashish Gupta treat?",
    a: "Dr. Gupta treats a wide range of cardiovascular conditions, including coronary artery blockages, heart attacks, heart failure, arrhythmias, and peripheral vascular disease. He specializes in complex angioplasties and pacemaker implantations.",
  },
  {
    q: "Where does Dr. Ashish Gupta practice?",
    a: "Dr. Gupta is the Director of Cardiology and CEO-Founder of WellMed Hospitals, located at 242, Sector 39, Gurugram, Haryana 122003.",
  },
  {
    q: "What are the consultation hours?",
    a: "Consultations are available from Monday to Saturday, 10:00 AM – 01:00 PM and 05:00 PM – 07:30 PM. Sunday consultations are by prior appointment only.",
  },
  {
    q: "How do I book an appointment?",
    a: "You can book an appointment by calling +91-72899 99292, via WhatsApp, or through the booking form on this website.",
  },
  {
    q: "Does WellMed Hospital handle cardiac emergencies?",
    a: "Yes. WellMed Hospitals is equipped with a state-of-the-art Cath Lab, modular OTs, and ICU/CCU facilities. We offer 24x7 emergency services including primary angioplasty for heart attacks.",
  },
  {
    q: "What is preventive cardiology?",
    a: "Preventive cardiology focuses on identifying your risk factors for heart disease early on and managing them through lifestyle modifications, diet, exercise, and medication before a serious cardiac event occurs.",
  },
  {
    q: "Are minimally invasive procedures available?",
    a: "Yes, the majority of Dr. Gupta's procedures, including coronary and peripheral angioplasties, are performed using minimally invasive catheter-based techniques, often through the radial artery (wrist), ensuring faster recovery.",
  },
  {
    q: "Do you offer pacemaker implantations?",
    a: "Yes, Dr. Gupta routinely performs permanent pacemaker, ICD, and CRT device implantations for patients with heart rhythm disorders or heart failure.",
  },
  {
    q: "What is Dr. Gupta's background?",
    a: "Dr. Ashish Gupta holds an MBBS, MD (Medicine), DM (Cardiology), and is a Fellow of the Society for Cardiovascular Angiography and Interventions (FSCAI, USA). He has over 20 years of experience and has successfully performed over 10,000 cardiac interventions.",
  },
];

export const facilities = [
  { title: "Advanced Cath Lab", desc: "State-of-the-art catheterization lab for precise cardiac imaging and interventions.", icon: "Activity" },
  { title: "Intensive Cardiac Care (CCU)", desc: "24/7 dedicated critical care unit for acute cardiac patients.", icon: "HeartPulse" },
  { title: "Non-Invasive Diagnostics", desc: "Comprehensive testing including Echo, TMT, Holter, and ECG.", icon: "Stethoscope" },
  { title: "Modular Operation Theatres", desc: "Advanced surgical suites meeting the highest infection control standards.", icon: "Scissors" },
  { title: "24×7 Emergency", desc: "Rapid response emergency department for immediate cardiac care.", icon: "Siren" },
  { title: "In-House Pharmacy & Lab", desc: "Round-the-clock pathology and medication access for convenience.", icon: "Microscope" },
];

export const credentials = [
  { label: "DM (Cardiology)", detail: "Advanced superspecialty training in Cardiology" },
  { label: "MD (Medicine)", detail: "Postgraduate specialization in Internal Medicine" },
  { label: "FSCAI (USA)", detail: "Fellow of the Society for Cardiovascular Angiography and Interventions" },
  { label: "MBBS", detail: "Bachelor of Medicine, Bachelor of Surgery" },
];
